/*******************************************************************************
/*******************************************************************************
* ReturnsServiceProvider */
/**
 * Service connection to the server.
 *******************************************************************************/
/* @ngInject */ export function ReturnsServiceProvider($injector) {
  this.httpServiceBase = '/books/returnReceipts/';
  this.httpServices = {
    getAccounts: function () {
      return this.post('getAccounts');
    },
    getEntityInfo: function (id) {
      return this.get('getEntityInfo/{0}'.format(id));
    },
    getFunds: function (id) {
      return this.get('getFunds/{0}'.format(id));
    },
    getLists: function (ledgerEntityTypes) {
      return this.post('getLists', { ledgerEntityTypes: ledgerEntityTypes });
    },
    getReceipt: function (id, dir) {
      return this.get('getReceipt/{0}/{1}'.format(id || 0, dir || 0));
    },
    /**
     * Receipt payment-elsewhere discovery - see receiptPaymentsDialog.js for
     * the problem this solves. Given a receipt's own id, returns every
     * still-active payment made elsewhere against one of its own charge
     * items.
     */
    getReceiptPayments: function (id) {
      return this.get('getReceiptPayments/{0}'.format(id));
    },
    getPaymentsBeforeRefundCutoff: function (id) {
      return this.get('getPaymentsBeforeRefundCutoff/{0}'.format(id));
    },
    save: function (receipt) {
      return this.post('saveReceipt', receipt);
    },
    search: function (filter) {
      return this.post('find', filter);
    }
  };

  /**
   * @ngdoc       service
   * @name        ReceiptsService
   * @module      csm.books.WriteReceipts
   * @description Receipts controller services.
   */
  this.$get = [
    'HTTPService',
    function (HTTPService) {
      return Object.assign(
        HTTPService.make(this.httpServiceBase),
        this.httpServices
      );
    }
  ];
}
